export const educationData = [
    {
        id: 1,
        institution: 'Conestoga College, Canada',
        course: 'Computer Programming and Analysis',
        startYear: '2020',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Joong-ang High Tech Academy, South Korea',
        course: 'Software Development Training Course',
        startYear: '2019',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'Hanyang University, South Korea',
        course: 'BA Economics/Chinese',
        startYear: '2007',
        endYear: '2013'
    },
]